import flow from 'lodash/flow'
import isFunction from 'lodash/isFunction'
import isNil from 'lodash/isNil'

import { convertToStringWithSeparator } from 'Shared/utils/number'

import { TO_FIXED_TWO_DECIMALS } from 'Core/constants'

export const roundFloat = (number: number, digits: number = TO_FIXED_TWO_DECIMALS): string =>
	number.toFixed(digits)

const isNumberPositive = (number: number): boolean => number > 0

const convertToNegative = (value: string, useParenthesis: boolean = false): string => useParenthesis ? `(${value})` : `-${value}`

export const withDollarSign = (dollar: string): string => `$${dollar}`

const digitsAfterDecimal = (value: string): number => (value.split('.')[1] || []).length

const addCurrencyTail = (value: string) => {
	const digitsAfterDot = digitsAfterDecimal(value)

	if (digitsAfterDot === 0) {
		return `${value}.00`
	}

	if (digitsAfterDot === 1) {
		return `${value}0`
	}

	return value
}

export const displayCurrency = (
	input: number | null | undefined,
	withCurrencySign = true,
	useParenthesisWhenNegative = false,
	fractionDigits: number = TO_FIXED_TWO_DECIMALS
): string => {
	if (isNil(input) || isNaN(input)) {
		return ''
	}

	if (input === 0) {
		return withCurrencySign ? withDollarSign('0.00') : '0.00'
	}

	const isPositive = isNumberPositive(input)
	const isInteger = Number.isInteger(input)

	const refinedInput = Math.abs(input)

	// Wrapper function to pass the constant `useParenthesisWhenNegative`
    const convertToNegativeWithParenthesis = (value: string) =>
        convertToNegative(value, useParenthesisWhenNegative);

	const pipeline: (input: number) => string = flow(
		[
			...(isInteger ? [] : [(n: number) => roundFloat(n, fractionDigits)]),
			convertToStringWithSeparator,
			addCurrencyTail,
			...(withCurrencySign ? [withDollarSign] : []),
			...(isPositive ? [] : [convertToNegativeWithParenthesis])
		].filter(isFunction)
	)

	return pipeline(refinedInput)
}

export const withCurrencyCode = (value: Key, currencyCode?: string) => {
	if (!currencyCode) {
		return `${value}`
	}

	return `${value} ${currencyCode}`
}
